import { TRACKING_EVENT_NAME } from '@adtrackify/at-tracking-event-types';

import { analytics } from './analytics';

import * as Logger from '@/lib/monitoring/logger';
import { identifyCurrentUser } from '@/lib/analytics/identify-current-user';
type ExternalLoginMethod = 'email' | 'otp';

type ExternalLoginFlow = 'standard' | 'shopify' | 'shopify_otp' | 'signup_auto';

interface LoginTrackingParams {
  email: string;
  userId: string;
  flow: ExternalLoginFlow;
  method?: ExternalLoginMethod;
}

async function identifyCurrentUserForLoginTracking(): Promise<void> {
  try {
    await identifyCurrentUser();
  } catch (err) {
    Logger.error('Failed to identify current user during login tracking', err instanceof Error ? err : new Error(String(err)));
  }
}

export function trackSuccessfulLogin(params: LoginTrackingParams): void {
  try {
    const { email, userId, flow, method = 'email' } = params;

    analytics.identify(userId, { email });

    void identifyCurrentUserForLoginTracking();

    analytics.track(TRACKING_EVENT_NAME.LOGIN, {
      email,
      flow,
      method,
    });
  } catch (err) {
    Logger.error('Failed to track successful login', err instanceof Error ? err : null, { params });
  }
}
